cb.define([], function () {
	var ST_st_storeoutlist_VM_Extend = {
		doAction: function (name,viewmodel) {
			if(this[name])
				this[name](viewmodel);
		},
		init: function (viewmodel) {
			//根据单据状态，设置行上的按钮是否显示
		    let gridModel = viewmodel.getGridModel();
			
		    gridModel.on('afterSetDataSource', () => {
				/*//仓库过滤条件只显示该门店仓库
				var storeid = cb.rest.AppContext.user.storeId;
				var proxy = cb.rest.DynamicProxy.create({
				  	settle: {
				  		url: "/bill/ref/getWarehousesFromStore",
				  		method: "POST" 
				  	} 
			 	});
			  	var params = {
				    storeId: storeid,
			  	};
			  	proxy.settle(params, (err, result) => {
			      	if (err) {
				        cb.utils.alert(err.message, 'error');
				        return;
			      	}
			
			      	if(result === undefined) {
			    	    cb.utils.alert("查询到门店仓库为空！", 'error');
			      	} else {
				      	//添加门店过滤条件只有周边门店
				      	var conditionWarehouse = {
				      		"isExtend": true,
									simpleVOs: []
				      	};
								conditionWarehouse.simpleVOs.push({
									field: 'id',
									op: 'in',
									value1: result
								});
				      	viewmodel.get('outWarehouse_name').setFilter(conditionWarehouse);
			      	}
		    	});*/
				
				
				const rows = gridModel.getRows();
				const actions = gridModel.getCache('actions');
				const actionsStates = [];
				rows.forEach(data => {
					const actionState = { };
					actions.forEach(action => {
						actionState[action.cItemName] = { visible: false };
						if (data.status == 0) {
							actionState["btnEdit"] = {visible:true};
							actionState["btnRowAudit"] = {visible:true};
							actionState["btnDelete"] = {visible:true};
						}
					});
					actionsStates.push(actionState);
				});
				gridModel.setActionsState(actionsStates);
			});
			
		}
	}

	try {		
		module.exports = ST_st_storeoutlist_VM_Extend;
	} catch (error) {

	}
	return ST_st_storeoutlist_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/ST/ST_st_storeoutlist_VM.Extend.js